import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OpenService } from '@app-services/open.service';

@Component({
  selector: 'app-banner-mobile',
  templateUrl: './banner-mobile.component.html',
  styleUrls: ['./banner-mobile.component.scss']
})
export class BannerMobileComponent implements OnInit {

  showBanner: boolean = false;
  nextShowInDays: number = 2;  
  bannerClosedAt: number | null = null;
  appInstalled: boolean = false
  isWhiteLabel: boolean = false;

  constructor(
    private router: Router,
    private openService: OpenService
  ) {}

  ngOnInit(): void {
    this.openService.getLayoutVars().subscribe((layoutVars) => {
      if(layoutVars) this.isWhiteLabel = true;
      
      this.checkBannerVisibility();
    });
  }

  checkAppInstallation() {
    const appUrlIOS = 'auto-arremate://';
    const appUrlAndroid = 'auto-arremate://';
    const fallbackUrlIOS = 'https://apps.apple.com/us/app/auto-arremate-exchange/id1488979731?l=pt-BR';
    const fallbackUrlAndroid = 'https://play.google.com/store/apps/details?id=br.com.actionlabs.autoarremate&hl=pt_BR&pli=1';

    const isAndroid = /android/.test(window.navigator.userAgent.toLowerCase());
    const isIOS = /iphone|ipod/.test(window.navigator.userAgent.toLowerCase());

    if (isIOS) {
      this.tryToOpenApp(appUrlIOS, fallbackUrlIOS);
    } else if (isAndroid) {
      this.tryToOpenApp(appUrlAndroid, fallbackUrlAndroid);
    }
  }

  tryToOpenApp(appUrl: string, fallbackUrl: string) {
    const start = Date.now();
    window.location.href = appUrl;

    setTimeout(() => {
      if (Date.now() - start < 1500) {
        this.appInstalled = false; 
        window.location.href = fallbackUrl;
      } else {
        this.appInstalled = true;
        this.showBanner = false;
      }
    }, 1000);
  }

  checkBannerVisibility() {
    if (this.appInstalled) {
      return;
    }

    const lastClosed = localStorage.getItem('bannerClosedAt');
    const interval = localStorage.getItem('bannerInterval');
    const isExchange = this.router.url.includes('arrematar');

    if (lastClosed && interval) {
      this.bannerClosedAt = parseInt(lastClosed);
      this.nextShowInDays = parseInt(interval);

      const daysPassed = Math.floor((Date.now() - this.bannerClosedAt) / (1000 * 60 * 60 * 24));

      if (daysPassed >= this.nextShowInDays) {
        this.showBanner = true; 
      }
    } else if(isExchange) {
      this.showBanner = true;
    }
  }

  closeBanner() {
    const currentDate = Date.now();
    const newInterval = this.calculateNextInterval();

    localStorage.setItem('bannerClosedAt', currentDate.toString());
    localStorage.setItem('bannerInterval', newInterval.toString());

    this.bannerClosedAt = currentDate;
    this.nextShowInDays = newInterval;

    this.showBanner = false;
  }

  calculateNextInterval(): number {
    if (this.nextShowInDays >= 30) {
      return 2;
    }
    return this.nextShowInDays * 2;
  }

  redirectToAppStore() {
    const fallbackUrlIOS = 'https://apps.apple.com/us/app/auto-arremate-exchange/id1488979731?l=pt-BR';
    const fallbackUrlAndroid = 'https://play.google.com/store/apps/details?id=br.com.actionlabs.autoarremate&hl=pt_BR&pli=1';

    const isAndroid = /android/.test(window.navigator.userAgent.toLowerCase());
    const isIOS = /iphone|ipod/.test(window.navigator.userAgent.toLowerCase());

    if (isIOS) {
      window.location.href = fallbackUrlIOS;
    } else if (isAndroid) {
      window.location.href = fallbackUrlAndroid;
    }
  }
}
